module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/15 veverka - hanger steak.jpg";